<template>
  <div class="header" @mouseleave="is_show=''">

    <!-- 导航开始 -->
    <nav class="navbar navbar-default" ref="header" id="header">
      <div class="navbar-header">
        <router-link to="/" class="navbar-brand" style="padding-top: 0px;" @click.native="is_show=''">
<!--          <img alt="Brand" src="../assets/news/top_logo_white.png" class="img-responsive" v-show="is_home">-->
          <img alt="Brand" src="../assets/news/top_logo_green.png" v-show="!is_home">
        </router-link>
      </div>
      <div>
        <ul class="nav">
          <li>
            <div :class="['header_title',is_active===1?'is_active':'']" @mouseenter="is_show=1">探究</div>
            <div v-show="is_show===1">
              <div class="downList">
                <div class="left">
                  <div class="product_title">产品</div>
                  <div :class="['product_dsc',is_active===1&&is_active_second===11?'is_active_second':'']">
                    <router-link to="/ducationPlatform" @click.native="is_show=''">麻吉星教发平台</router-link>
                  </div>
                  <div :class="['product_dsc',is_active===1&&is_active_second===1?'is_active_second':'']">
                    <router-link to="/Teaching" @click.native="is_show=''">麻吉星教学系统</router-link>
                  </div>
                  <div :class="['product_dsc',is_active===1&&is_active_second===3?'is_active_second':'']">
                    <router-link to="/synchronousClassroom" @click.native="is_show=''">麻吉星同步课堂</router-link>
                  </div>
                  <div :class="['product_dsc',is_active===1&&is_active_second===4?'is_active_second':'']">
                    <router-link to="/maJixingClass" @click.native="is_show=''">麻吉星班级</router-link>
                  </div>
                  <div :class="['product_dsc',is_active===1&&is_active_second===5?'is_active_second':'']">
                    <router-link to="/treasureBox" @click.native="is_show=''">麻吉星百宝盒</router-link>
                  </div>
                  <div :class="['product_dsc',is_active===1&&is_active_second===6?'is_active_second':'']">
                    <router-link to="/AppDownload" @click.native="is_show=''">麻吉星魔法教师App</router-link>
                  </div>
                  <div :class="['product_dsc',is_active===1&&is_active_second===2?'is_active_second':'']">
                    <router-link to="/Creation" @click.native="is_show=''">麻吉星创作系统</router-link>
                  </div>
                </div>
                <div class="right">
                  <div class="product_title">产品支持</div>
                  <div :class="['product_dsc',is_active===1&&is_active_second===7?'is_active_second':'']">
                    <router-link to="/softwareDownload" @click.native="is_show=''">软件下载</router-link>
                  </div>
                  <div :class="['product_dsc',is_active===1&&is_active_second===8?'is_active_second':'']">
                    <router-link to="/productPage" @click.native="is_show=''">产品彩页</router-link>
                  </div>
                  <div :class="['product_dsc',is_active===1&&is_active_second===9?'is_active_second':'']">
                    <router-link to="/productTutorial" @click.native="is_show=''">产品教程</router-link>
                  </div>
                  <div :class="['product_dsc',is_active===1&&is_active_second===10?'is_active_second':'']">
                    <router-link to="/question" @click.native="is_show=''">常见问题</router-link>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div :class="['header_title',is_active===2?'is_active':'']" @mouseenter="is_show=2">创造</div>
            <div v-show="is_show===2">
              <div class="downList downList1">
                <div class="downList_box">
                  <div :class="['font',is_active===2&&is_active_second===1?'is_active_second':'']">
                    <router-link to="/AllWork" @click.native="is_show=''">麻吉星动画</router-link>
                  </div>
                  <div :class="['font',is_active===2&&is_active_second===2?'is_active_second':'']">
                    <router-link to="/news_list" @click.native="is_show=''">麻吉星动态</router-link>
                  </div>
                  <div :class="['font',is_active===2&&is_active_second===3?'is_active_second':'']">
                    <router-link to="/SchoolList" @click.native="is_show=''">麻吉星学校</router-link>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div :class="['header_title',is_active===3?'is_active':'']" @mouseenter="is_show=3">协作</div>
            <div v-show="is_show===3">
              <div class="downList downList2">
                <div class="left">
                  <div class="product_title">麻吉星团队</div>
                  <div :class="['product_dsc',is_active===3&&is_active_second===1?'is_active_second':'']">
                    <router-link :to="{name:'team', params: {id:1}}" @click.native="is_show=''">专家顾问群</router-link>
                  </div>
                  <div :class="['product_dsc',is_active===3&&is_active_second===2?'is_active_second':'']">
                    <router-link :to="{name:'team', params: {id:2}}" @click.native="is_show=''">教学顾问群</router-link>
                  </div>
                </div>
                <div class="right right1">
                  <div class="product_title">麻吉星课程资源</div>
                  <div :class="['product_dsc',is_active===3&&is_active_second===3?'is_active_second':'']">
                    <router-link to="/lessonSelection" @click.native="is_show=''">精选课例</router-link>
                  </div>
                  <div :class="['product_dsc',is_active===3&&is_active_second===4?'is_active_second':'']">
                    <router-link to="/expertForm" @click.native="is_show=''">专家论坛</router-link>
                  </div>
                </div>
                <div class="right right2">
                  <div class="product_title">麻吉星共读</div>
                  <div :class="['product_dsc',is_active===3&&is_active_second===5?'is_active_second':'']">
                    <router-link to="/read" @click.native="is_show=''">麻吉星共读</router-link>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div :class="['header_title',is_active===4?'is_active':'']" @mouseenter="is_show=4">关于</div>
            <div v-show="is_show===4">
              <div class="downList downList1">
                <div class="downList_box">
                  <div :class="['font',is_active===4&&is_active_second===1?'is_active_second':'']">
                    <router-link :to="{name:'PinPai', params: {id:1}}" @click.native="is_show=''">品牌故事</router-link>
                  </div>
                  <div :class="['font',is_active===4&&is_active_second===2?'is_active_second':'']">
                    <router-link :to="{name:'PinPai', params: {id:2}}" @click.native="is_show=''">投资我们</router-link>
                  </div>
                  <div :class="['font',is_active===4&&is_active_second===3?'is_active_second':'']">
                    <router-link :to="{name:'PinPai', params: {id:3}}" @click.native="is_show=''">联系我们</router-link>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="message">
        <div class="messages" v-if="token">
          <el-badge :value="notice_count" class="item" :hidden="notice_count===0">
            <i class="iconfont" @click="showInfo" style="cursor: pointer">&#xe634;</i>
          </el-badge>
        </div>
        <div v-show="messageShow">
          <div class="message_header"></div>
          <div class="message_box">
            <div style="color: #333333;text-align: center;padding: 12px 0;border-bottom: thin solid #D2D2D2">消息</div>
            <div class="message_content">
              <div v-if="info_count&&info_count>0">
                <div class="message_content_box" @click="pushRouter(item)" v-for="item in list" :key="item.id">
                  <el-badge is-dot :hidden="item.status">
                    <span class="content_box_span">{{item.title_str}}</span>
                  </el-badge>
                  <div class="content_box_span">{{item.create_time}}</div>
                  <div>
                    <span class="top" v-if="item.type===2">收到“{{item.nickname}}”的{{item.title_str.slice(0,-2)}}。</span>
                    <span class="top" v-if="item.type===1">收到“{{item.nickname}}”的评论:{{item.send_notice_comment_content}}。</span>
                    <span class="top" v-if="item.type===3">{{item.classroom_name}}</span>
                    <span class="top" v-if="item.type===4">{{item.classroom_name}}</span>
                    <i class="el-icon-delete" style="position: absolute;right: 25px;cursor: pointer;top: 13px"
                       @click="del($event,item)"></i>
                  </div>
                </div>
              </div>
              <div v-else>
                <div style="text-align: center;padding-top: 20px">
                  <img src="../assets/images/news/info.png" alt="" style="width: 70%">
                </div>
                <div style="text-align: center;color: #999999">没有收到任何消息</div>
              </div>
            </div>

            <div class="message_footer">
              <div class="footer" @click="delAll">全部删除</div>
              <div class="footer" @click="allTags">全部标记已读</div>
            </div>
          </div>
        </div>
      </div>
      <ul v-if="token==null || token===''" class="nav navbar-nav navbar-right login_btn" @mouseenter="is_show = ''">
        <li style="width: 80px">
          <router-link to="/login">
            <span class="login">登录</span>
          </router-link>
        </li>
      </ul>
      <ul v-else class="nav navbar-nav navbar-right " id="tt" @mouseenter="is_show = ''">
        <li class="dropdown" id="tx">
          <router-link to="/my_works?asid=1">
            <img v-if="avator===''" src="../assets/images/tx.png" class="img-responsive" style="width: 50px;">
            <div v-if="avator!=='undefined'&&avator!==''"
                 style="width: 50px;height: 50px;border-radius: 50%;overflow: hidden;">
              <img :src="avator" style="width: 100%;height: 100%;object-fit: cover">
            </div>
          </router-link>


          <ul class="dropdown-menu touxiang" style="width: 180px;height: 230px;
box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);">
            <li style="height: 64px;color: #4A4B4B;padding-top: 22px;font-size: 16px;font-weight: bold" v-if="nickname!=='undefined'">{{nickname}}</li>
            <li style="height: 64px;color: #4A4B4B;padding-top: 22px;font-size: 16px;font-weight: bold" v-else>{{username}}</li>


<!--            <li style="color: black">{{address}}</li>-->
            <li class="divider"></li>
            <li style="margin: 30px 0;font-size: 16px;height: 15px;background: #FFFFFF;line-height: 15px">
              <router-link to="/personalCenter?asid=1">个人中心</router-link>
            </li>
            <li style="margin: 30px 0;font-size: 16px;height: 15px;background: #FFFFFF;line-height: 15px">
              <router-link to="act_code?asid=5">产品激活</router-link>
            </li>
            <li @click="loginout"  style="margin: 30px 0;font-size: 16px;height: 15px;background: #FFFFFF;line-height: 15px"><a href="#">退出登录</a></li>
          </ul>
        </li>
      </ul>

    </nav>
    <!-- 导航结束 -->
  </div>
</template>

<script>
  import wx from "weixin-js-sdk";
  export default {
    name: "header_nav",
    data() {
      return {
        token: '',
        avator: '',
        nickname: '',
        username: '',
        address: '',
        messageShow: false,
        notice_count: '',
        list: [],
        info_count: 0,
        is_home: false,
        is_active: 1,//1级菜单选择
        is_active_second: 1,//2级菜单选择
        is_show: ''
      }
    },
    updated() {
      //检测token过期
      let token = this.$route.query.token;
      if (token) {
        this.token = token;
        localStorage.token = token;
        //获取个人信息
        this.$http.post('api/user_action/getUserAllInfo').then((res) => {
          //保存信息
          this.avator = res.data.data.avator;
          this.$store.commit('set_userinfo', {
            username: res.data.data.username,
            avator: res.data.data.avator,
            address: res.data.data.address,
            is_vip: res.data.data.is_vip,
            nickname: res.data.data.nickname,
            uid: res.data.data.uid
          });
        })
      } else {
        this.token = localStorage.token
      }
    },
    methods: {
      loginout() {
        let path = location.href.split('#')[1];
        if (path === '/') {
          this.$store.commit('set_userinfo', {});
          this.$store.commit('set_token', '');
          // location.reload();
          this.token = null;
        } else {
          this.$router.push('/');
          this.$store.commit('set_userinfo', {});
          this.$store.commit('set_token', '');
        }
        localStorage.removeItem('lastPath');
        localStorage.removeItem('fullPath');
        sessionStorage.removeItem('openid');
        sessionStorage.removeItem('unionid');
        this.notice_count = 0;
      },
      del(event, item) {
        event.stopPropagation();
        this.$http.post('api/user_notice/delNoticeReadOne', {id: item.id}).then(res => {
          if (res.data.ret === 200) {
            this.list.forEach((e, index) => {
              if (e.id === item.id) {
                this.list.splice(index, 1);
                this.info_count = this.info_count - 1;
                if(!item.status){
                  this.notice_count -= 1;
                }
              }
            })
          }
        })
      },
      showInfo(event) {
        event.stopPropagation();
        this.messageShow = !this.messageShow;
        this.is_show = '';
      },
      getUserNoticeList() {
        this.$http.post('api/user_notice/getUserNoticeList', {
          current_page: this.current_page,
          per_page: 10000
        }).then(res => {
          let list_temp = res.data.data.data;
          if (list_temp) {
            this.notice_count = 0;
            this.list = [];
            list_temp.forEach(e => {
              if (e.type === 1 || e.type === 2 || e.type === 3 || e.type === 4) {
                if (e.status === 1) {
                  this.notice_count++;
                }
                if (e.type === 1) {
                  e.title_str = '评论通知'
                } else if (e.type === 2) {
                  e.title_str = '点赞通知'
                } else if (e.type === 3) {
                  e.title_str = '系统消息'
                } else {
                  e.title_str = '系统消息'
                }
                if (e.status === 1) {
                  e.status = false
                } else {
                  e.status = true
                }
                this.list.push(e);
              }
            });
            this.info_count = this.list.length | 0;
          }else{
            this.notice_count = 0;
            this.info_count = 0;
          }
        })
      },
      //删除全部
      delAll() {
        this.$http.post('api/user_notice/delNoticeReadAll').then(res => {
          if (res.data.ret === 200) {
            this.list = [];
            this.info_count = 0;
            this.notice_count = 0;
          }
        })
      },
      //全部标记已读
      allTags() {
        this.$http.post('api/user_notice/setNoticeReadAll').then(res => {
          if (res.data.ret === 200) {
            this.list.forEach(e => {
              e.status = true;
            });
            this.notice_count = 0;
          }
        })
      },
      //单个已读
      pushRouter(item) {
        this.messageShow = false;
        this.$http.post('api/user_notice/setNoticeReadOne', {id: item.id}).then(res => {
          if (res.data.ret === 200) {
            if (item.specific_works_id !== 0) {
              this.$router.push(`/VideoInfo?wid=${item.specific_works_id}&specific_comment_id=${item.specific_comment_id}&currentPage=1`);
            }
            if (item.specific_article_id !== 0) {
              this.$router.push(`/listencourse?coursesection=${item.specific_article_id}&specific_comment_id=${item.specific_comment_id}&activeName=second&currentPage=1`);
            }
            if(!item.status){
              this.notice_count -= 1;
            }
            item.status = true;
          }
        })
      },
      checkToken() {
        this.$http.post('/api/login/checkToken').then((res) => {
          if (res.data.ret === 400) {
            this.$store.commit('set_userinfo', {});
            localStorage.removeItem('token');
            this.token = localStorage.token;
          }
        })
      },
    },
    mounted() {
      this.$EventBus.$on("msg", (msg) => {
        this.messageShow = msg;
      });
      let that = this;
      setInterval(function () {
        if(that.token){
          that.getUserNoticeList();
        }
      },1000*60*5);

      this.$EventBus.$on('name',(msg)=>{
        this.nickname =  msg;
      });

      this.$EventBus.$on('token',(msg)=>{
        this.nickname =  msg;
      });

      this.$EventBus.$on('avator',(msg)=>{
        this.avator =  msg;
      });
    },
    watch: {
      '$route': {
        handler() {
          this.token = localStorage.token;
          this.username = localStorage.username;
          this.nickname = localStorage.nickname;
          this.avator = localStorage.avator;
          this.address = localStorage.address;
          switch (this.$route.path) {
            case '/Teaching':
              this.is_active = 1;
              this.is_active_second = 1;
              break;
            case '/Creation':
              this.is_active = 1;
              this.is_active_second = 2;
              break;
            case '/synchronousClassroom':
              this.is_active = 1;
              this.is_active_second = 3;
              break;
            case '/maJixingClass':
              this.is_active = 1;
              this.is_active_second = 4;
              break;
            case '/treasureBox':
              this.is_active = 1;
              this.is_active_second = 5;
              break;
            case '/AppDownload':
              this.is_active = 1;
              this.is_active_second = 6;
              break;
            case '/softwareDownload':
              this.is_active = 1;
              this.is_active_second = 7;
              break;
            case '/productPage':
              this.is_active = 1;
              this.is_active_second = 8;
              break;
            case '/productTutorial':
              this.is_active = 1;
              this.is_active_second = 9;
              break;
            case '/productTutorialInfo':
              this.is_active = 1;
              this.is_active_second = 9;
              break;
            case '/question':
              this.is_active = 1;
              this.is_active_second = 10;
              break;
            case '/questionInfo':
              this.is_active = 1;
              this.is_active_second = 10;
              break;
            case '/ducationPlatform':
              this.is_active = 1;
              this.is_active_second = 11;
              break;
            case '/AllWork':
              this.is_active = 2;
              this.is_active_second = 1;
              break;
            case '/hot':
              this.is_active = 2;
              this.is_active_second = 1;
              break;
            case '/idiom':
              this.is_active = 2;
              this.is_active_second = 1;
              break;
            case '/create':
              this.is_active = 2;
              this.is_active_second = 1;
              break;
            case '/news_list':
              this.is_active = 2;
              this.is_active_second = 2;
              break;
            case '/news_info':
              this.is_active = 2;
              this.is_active_second = 2;
              break;
            case '/SchoolList':
              this.is_active = 2;
              this.is_active_second = 3;
              break;
            case '/SchoolInfo':
              this.is_active = 2;
              this.is_active_second = 3;
              break;
            case '/team1':
              this.is_active = 3;
              this.is_active_second = 1;
              break;
            case '/team2':
              this.is_active = 3;
              this.is_active_second = 2;
              break;
            case '/lessonSelection':
              this.is_active = 3;
              this.is_active_second = 3;
              break;
            case '/lessonSelectionInfo':
              this.is_active = 3;
              this.is_active_second = 3;
              break;
            case '/expertForm':
              this.is_active = 3;
              this.is_active_second = 4;
              break;
            case '/expertFormList':
              this.is_active = 3;
              this.is_active_second = 4;
              break;
            case '/expertFormInfo':
              this.is_active = 3;
              this.is_active_second = 4;
              break;
            case '/read':
              this.is_active = 3;
              this.is_active_second = 5;
              break;
            case '/coursedetails':
              this.is_active = 3;
              this.is_active_second = 5;
              break;
            case '/listencourse':
              this.is_active = 3;
              this.is_active_second = 5;
              break;
            case '/PinPai1':
              this.is_active = 4;
              this.is_active_second = 1;
              break;
            case '/PinPai2':
              this.is_active = 4;
              this.is_active_second = 2;
              break;
            case '/PinPai3':
              this.is_active = 4;
              this.is_active_second = 3;
              break;
            default:
              this.is_active = '';
              break;
          };
        },
        immediate: true
      },
      'token':function () {
        if(this.token){
          this.getUserNoticeList();
        }
      }
    },
    created() {
      let uid = localStorage.getItem('uid');
      if(uid&&uid>0){
        this.checkToken();
      }
      if(this.token){
        this.getUserNoticeList();
      }
    }
  }
</script>

<style scoped>
  button {
    border-radius: 50%;
    padding: 0;
    border: 0;
    margin: 20px 10px 0 0;
  }

  .header {
    height: 96px;
    background-color: rgb(255, 255, 255);
    position: sticky;
    z-index: 99;
    top: 0;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
  }

  .navbar {
    height: 100%;
    width: 1180px;
    margin: 0 auto;
    display: flex;
    /*justify-content: space-between;*/
    align-items: center;
  }

  /*导航开始*/
  /*去掉导航的默认样式*/
  .navbar-default {
    background-color: transparent;
    border: none;

  }

  .navbar-brand{
    height: 65px;
    padding: 0;
  }

  .navbar-default .navbar-nav > li > a {
    color: #333;
  }

  .navbar-default .navbar-nav > li > a {
    font-weight: 500;
    font-size: 20px;
  }

  #header .active {
    color: white;
  }

  #header .active:hover {
    color: #167c8a;
  }


  /*头像定位*/
  #tx {
    border-radius: 50%;
  }

  #tx > .nav > li > a > img {
    position: relative;
  }

  #tx > .touxiang {
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
  }

  /*头像下面字体*/
  .touxiang > li {
    text-align: center;
  }

  .navbar-right {
    margin-right: 0;
  }

  #tt {
    padding-top: 0px;
  }

  .nav > li > a {
    padding: 0 30px;
  }

  .nav {
    margin-left: 84px;
  }

  /*导航结束*/

  /*小于768*/
  @media (max-width: 768px) {
    .navbar-brand > img {
      width: 200px;
      height: auto;

    }

    .navbar-brand {
      padding-left: 0;
    }

    .navbar {
      margin-bottom: 10px;
    }


  }

  /*大于768，小于1024*/
  @media (min-width: 768px) and (max-width: 1024px) {
    .navbar-default .navbar-nav > li > a {
      padding: 18px 12px 22px;
      /*padding-top: 18px;*/
    }
  }

  .message_box {
    width: 375px;
    height: 370px;
    background-color: #FAFAFA;
    position: absolute;
    margin-left: 50%;
    transform: translateX(-50%);
    border: thin solid #D2D2D2;
    z-index: 999999;
    overflow: hidden;
  }

  .message_header {
    display: inline-block;
    width: 0;
    /*height: 5px;*/
    border: 5px solid black;
    border-color: transparent transparent #D2D2D2 transparent;
    position: absolute;
    bottom: -1px;
    left: 50%;
    /*margin-left: 50%;*/
    transform: translateX(-50%);
  }

  .message_content {
    height: 285px;
    overflow-y: scroll;
    background-color: white;
    position: relative;
  }

  .message_footer {
    height: 40px;
    border-top: thin solid #D2D2D2;
    cursor: pointer;
  }

  .footer {
    display: inline-block;
    color: #666666;
    font-size: 14px;
    width: 49%;
    text-align: center;
    line-height: 40px;
  }

  .footer:nth-child(1) {
    border-right: thin solid #D2D2D2;
  }

  .message_content_box {
    padding: 10px 25px;
    border-bottom: thin solid #D2D2D2;
    cursor: pointer;
    position: relative;
  }

  .message_content_box:nth-last-child(1) {
    border-bottom: none;
  }

  .content_box_span {
    color: #333333;
    font-size: 16px;
  }

  .content_box_span:nth-child(2) {
    color: #999999;
    font-size: 14px;
    /*position: absolute;*/
    /*right: 25px;*/
  }

  .top {
    /*width: 88%;*/
    display: inline-block;
    font-size: 16px;
    color: #666666;
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    /*white-space: nowrap;*/
  }

  .login {
    display: inline-block;
    width: 80px;
    height: 32px;
    background-image: url("../assets/news/top_btn_login.png");
    border-radius: 16px;
    text-align: center;
    color: white;
    font-size: 16px;
    line-height: 32px;
  }

  .login_btn a {
    padding: 0 !important;
  }

  .login_btn {
    margin-left: 321px;
  }

  .nav {
    display: flex;
  }

  .nav li {
    width: 100px;
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    position: relative;
    cursor: pointer;
  }

  .downList {
    width: 588px;
    height: 305px;
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-39%);
    display: flex;
    padding-left: 74px;
    padding-top: 24px;
    color: rgba(102, 102, 102, 1);
    font-size: 16px;
    z-index: 9999;
  }

  .right {
    margin-left: 135px;
    text-align: left;
  }

  .left div {
    text-align: left;
  }

  .product_dsc {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    margin-bottom: 21px;
    line-height: 12px;
  }

  .product_title {
    font-weight: bold;
    margin-bottom: 32px;
    line-height: 16px;
  }

  .right1 {
    margin-left: 120px;
  }

  .right2 {
    margin-left: 88px;
  }

  .downList1 {
    width: 150px;
    height: 136px;
    padding: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
  }

  .downList1 .downList_box {
    text-align: center;
    width: 100%;
    padding: 30px 0;
  }

  .downList_box div {
    line-height: 12px;
  }

  .downList_box div:nth-of-type(2) {
    margin: 20px 0;
  }

  .downList2 {
    width: 690px;
    height: 150px;
    padding-left: 70px;
    padding-top: 25px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
  }

  .is_active {
    color: rgba(43, 156, 165, 1);
    font-weight: bold;
  }

  .header_title:hover {
    color: rgba(43, 156, 165, 1);
    font-weight: bold;
  }

  .downList_box a {
    color: rgba(102, 102, 102, 1);
  }

  .product_dsc a {
    color: rgba(102, 102, 102, 1);
  }

  .downList_box div:hover a {
    color: rgba(43, 156, 165, 1);
  }

  .product_dsc:hover a {
    color: rgba(43, 156, 165, 1);
  }

  .is_active_second a {
    color: rgba(43, 156, 165, 1);
  }

  .font {
    font-size: 14px;
  }

  #tx{
    width: 50px;
    height: 50px;
  }
  #tx a{
    display: inline-block;
    width: 50px;
    padding: 0;
  }
  #tt{
    margin-left: 359px;
  }
  .message{
    position: absolute;
    right: 121px;
    top: 25px;
  }
  #tx:hover .dropdown-menu{
    display: block;
  }
  #tx ul{
    padding: 0;
  }
  #tx li{
    width: 100%;
    text-align: center;
    padding: 0;
    font-size: 16px;
  }

  #tx li a{
    width: 100%;
    color: #333;
    font-size: 14px;
    display: inline-block;
    height: 100%;
    padding: 0;
  }
  #tx li:hover a{
    background: white;
    color: #2B9CA5;
  }
  .dropdown-menu .divider{
    margin: 0;
  }
  .dropdown-menu>li>a:focus, .dropdown-menu>li>a:hover{
    background: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/header_nav.vue